"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotateGridPosition = void 0;
const position_1 = require("./position");
const rotateGridPosition = (gridSize, position) => (0, position_1.packPosition)(gridSize.width - 1 - (0, position_1.unpackX)(position), gridSize.height - 1 - (0, position_1.unpackY)(position));
exports.rotateGridPosition = rotateGridPosition;
